import React from 'react'

const Default = (props) => {
	const {
		pathname,
	} = props

	return (
		<props.content pathname={pathname} />
	)
}

export default Default



// WEBPACK FOOTER //
// ./src/common/components/page/default.js